import ModalVerificationCheckEmail from './ModalVerificationCheckEmail';

export default ModalVerificationCheckEmail;
